module.exports = __webpack_public_path__ + "static/img/icon_area.aae9ddf5.svg";